import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
import { Link } from 'react-router-dom';

const MainScope = styled.div`
  max-width: 800px;
  border: 1px solid silever;
  border-radius: 5px;
  padding: 5px;
`

const svgContact = <svg className="h-8 w-8 text-black inline"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round">  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />  <polyline points="22,6 12,13 2,6" /></svg>
const Flow = props => {
  const url ='/STEMON/';  
    return (
          <MainScope >
            <p className='mt-2 text-lg'>{props.id}.&ensp;{props.title}</p>
            <div className='mt-2'>
              <p className='mt-2 ml-5'>{props.content}</p>
              { props.id =='1' && 
               <Link to={url + 'Contact'}><button className='mt-2 ml-5 font-bold bg-orange-200 text-blue p-5 rounded'>お問い合わせはこちら&ensp;{svgContact}</button></Link>
              }
            </div>

          </MainScope>        
      );
}

export default Flow;